<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="3" class="my-1">
            <!-- <b-navbar-nav>
              <b-button @click="goBack" size="sm" class="ml-2 mr-2" variant="outline-secondary"
                style="font-size: 0.675rem">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav> -->
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <label>Date Type</label>
            <model-list-select :list="dateTypeList" v-model="Filter.DateTypeFilter" option-value="value"
              option-text="text" placeholder="Select Date Type"
              @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></model-list-select>
          </b-col>
          <b-col md="3">
            <label>Date</label>
            <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
              :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
              @update="getSlinePlanningList('Normal', '0', '0', '1', '1')"></date-range-picker>
          </b-col>
          <b-col md="2">
            <label>Shipping Line</label>
            <model-list-select :list="$store.getters['commonDropdownMaster/getAllPendingSlineInvDDList']"
              v-model="Filter.slineFilter" option-value="value" option-text="label" placeholder="Select Shipping Line"
              @input="getSlinePlanningList('Normal', '0', '0', '1', '1')" />
            <!-- <model-list-select :list="$store.getters['common/getAllShippingLineList']" v-model="Filter.slineFilter"
              option-value="shippingId" option-text="shippingLine" placeholder="Select Shipping Line"
              @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></model-list-select> -->
          </b-col>
          <b-col md="2">
            <label>Transport Type</label>
            <model-list-select :list="transportTypeList" v-model="Filter.TransportTypeFilter" option-value="value"
              option-text="value" placeholder="Select Transport Type"
              @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></model-list-select>
          </b-col>
          <b-col md="2">
            <label>Payment Type</label>
            <model-list-select :list="paymentTypeList" v-model="Filter.paymentTypeFilter" option-value="value"
              option-text="text" placeholder="Select Payment Type"
              @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></model-list-select>
          </b-col>
          <b-col md="2">
            <label>SOB Status</label>
            <model-list-select @input="getSlinePlanningList('Normal', '0', '0', '1', '1')" :list="SOBStatusList"
              v-model="Filter.SOBFilter" option-value="inv" option-text="int"
              placeholder="Select SOB Status"></model-list-select>
          </b-col>
          <b-col md="2">
            <b-button class="pull-right ml-1 mt-5" :variant="Filter.DateTypeFilter ||
              Filter.JobNoFilter ||
              Filter.clientFilter ||
              Filter.slineFilter ||
              Filter.TransportTypeFilter ||
              Filter.paymentTypeFilter ||
              Filter.SOBFilter ||
              Filter.ShipemntTypeFilter ||
              Filter.PORFilter ||
              Filter.POLFilter ||
              Filter.PODFilter ||
              Filter.FPODFilter ||
              Filter.statusFilter ||
              Filter.commonFilter ||
              Filter.createdByFilter ||
              Filter.branchFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.DateTypeFilter ||
                  Filter.JobNoFilter ||
                  Filter.clientFilter ||
                  Filter.slineFilter ||
                  Filter.TransportTypeFilter ||
                  Filter.paymentTypeFilter ||
                  Filter.SOBFilter ||
                  Filter.ShipemntTypeFilter ||
                  Filter.PORFilter ||
                  Filter.POLFilter ||
                  Filter.PODFilter ||
                  Filter.FPODFilter ||
                  Filter.statusFilter ||
                  Filter.commonFilter ||
                  Filter.createdByFilter ||
                  Filter.branchFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-5" v-if="getPaymentList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getPaymentList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>

          </b-col>

          <b-col cols="9">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
          <!-- <b-col cols="3">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col> -->

          <b-col cols="12">
            <div v-if="visible">
              <b-card>
                <b-collapse v-model="visible" id="collapse-2">
                  <b-row>
                    <b-col md="3">
                      <label>Date Type</label>
                      <model-list-select :list="dateTypeList" v-model="Filter.DateTypeFilter" option-value="value"
                        option-text="text" placeholder="Select Date Type"
                        @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>Date</label>
                      <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange"
                        :startDate="startDate" :endDate="endDate" :locale-data="locale"
                        :disabled="Filter.DFlag ? true : false"
                        @update="getSlinePlanningList('Normal', '0', '0', '1', '1')"></date-range-picker>
                    </b-col>
                    <b-col md="3">
                      <label>Job NO Filter</label>
                      <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Job NO Filter"
                        id="JobNoFilter" name="JobNoFilter" autocomplete="off" v-model="Filter.JobNoFilter"
                        @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <label>Transport Type</label>
                      <model-list-select :list="transportTypeList" v-model="Filter.TransportTypeFilter"
                        option-value="value" option-text="value" placeholder="Select Transport Type"
                        @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>

                    <b-col md="3">
                      <label>Shipment Type</label>
                      <model-list-select :list="shipmentTypeList" v-model="Filter.ShipemntTypeFilter"
                        option-value="value" option-text="value" placeholder="Select Shipment Type"
                        @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>

                    <b-col md="3">
                      <label>Shipping Line</label>
                      <model-list-select :list="$store.getters['commonDropdownMaster/getAllPendingSlineInvDDList']"
                        v-model="Filter.slineFilter" option-value="value" option-text="label"
                        placeholder="Select Shipping Line"
                        @input="getSlinePlanningList('Normal', '0', '0', '1', '1')" />
                      <!-- <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                        v-model="Filter.slineFilter" option-value="shippingId" option-text="shippingLine"
                        placeholder="Select Shipping Line"
                        @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></model-list-select> -->
                    </b-col>
                    <b-col md="3">
                      <label>Client</label>
                      <model-list-select :list="$store.getters['common/getAllClientList']" id="clientFilter"
                        v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                        placeholder="Select Client Name"
                        @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>Branch</label>
                      <model-list-select :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                        v-model="Filter.branchFilter" option-value="pickupId" option-text="pickupLocation"
                        placeholder="All"
                        @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>

                    <b-col md="3">
                      <label>POR</label>
                      <model-list-select :list="$store.getters['common/getAllPORList']" id="PORFilter"
                        v-model="Filter.PORFilter" option-value="pickupId" option-text="pickupLocation"
                        placeholder="All"
                        @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>POL</label>
                      <model-list-select :list="$store.getters['common/getAllPOLList']" id="POLFilter"
                        v-model="Filter.POLFilter" option-value="pickupId" option-text="pickupLocation"
                        placeholder="All"
                        @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>POD</label>
                      <model-list-select :list="$store.getters['common/getAllPODList']" id="PODFilter"
                        v-model="Filter.PODFilter" option-value="pickupId" option-text="pickupLocation"
                        placeholder="All"
                        @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>FPOD</label>
                      <model-list-select :list="$store.getters['common/getAllLocationDetailsFinalList']" id="FPODFilter"
                        v-model="Filter.FPODFilter" option-value="pickupId" option-text="pickupLocation"
                        placeholder="All"
                        @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>

                    <b-col md="3">
                      <label>Common Filter</label>
                      <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                        id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
                        @input="getSlinePlanningList('Normal', '0', '0', '1', '1')"></b-form-input>
                    </b-col>

                    <b-col md="3">
                      <label>
                        <b> Created User </b>
                      </label>
                      <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                        @input="getSlinePlanningList('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                        option-value="userId" option-text="employeeName"
                        placeholder="Select Created User"></model-list-select>
                    </b-col>

                    <b-col md="12" class="mt-2">
                      <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                        variant="outline-danger">Reset</b-button>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </div>
          </b-col>

          <b-col cols="12">
            <div class="d-flex align-items-center gap-2">
              <b-form-checkbox :checked="allSelected" @change="toggleSelectAll($event)" />
              <b-button variant="primary" @click="openConfirmModal(selectedCheckBoxRows)" class="btn-sm"
                :disabled="selectedCheckBoxRows.length <= 0">
                Finalize Request
              </b-button>
            </div>
          </b-col>
          <b-col cols="12" class="table-responsive tableMain ">

            <b-table show-empty stacked="md" responsive :items="getPaymentList" :fields="PaymentFields"
              primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
              class="position-relative" :row-class="rowClass">
              <template slot="checkbox" slot-scope="row0">
                <div class="d-flex align-items-center gap-2">
                  <b-button @click="row0.toggleDetails" class="mr-2" size="sm" style="font-size: 0.675rem"
                    variant="outline-info">
                    <md-icon>{{ row0.detailsShowing ? "expand_less" : "expand_more" }}</md-icon>
                    {{ row0.detailsShowing ? "Hide More" : "Show More" }}
                    Details
                  </b-button>


                  <b-form-checkbox :disabled="row0.item.sprf_transaction_no" v-model="selectedCheckBoxRows" :value="{
                    paymentModuleType: row0.item.paymentModuleType,
                    sprf_id: row0.item.sprf_id,
                    sps_id: row0.item.sps_id,
                    sps_is_sortlist: row0.item.sps_is_sortlist,
                    sps_is_finalized: row0.item.sps_is_finalized,
                    invoicePayID: row0.item.invoicePayID,
                    invoiceID: row0.item.invoiceID,
                    invoiceAmtID: row0.item.invoiceAmtID,
                    JobId: row0.item.JobId,
                    JobNo: row0.item.JobNo,
                    InvNumber: row0.item.invoiceNumber,
                    InvAmt: row0.item.amount,
                    currency: row0.item.currency,
                    SlineName: row0.item.SlineName,
                    shippingId: row0.item.shippingId,
                    fk_sa_id: row0.item.fk_sa_id || null,
                    JobDate: row0.item.JobDate || null,
                    paymentCreatedDate: row0.item.paymentCreatedDate || null,
                    invoiceType: row0.item.invoiceType || null,
                    amount: row0.item.amount || null,
                    payTo: row0.item.payTo || null,
                    IFSCCode: row0.item.IFSCCode || null,
                    BranchName: row0.item.BranchName || null,
                    selectedAmt: row0.item.amount || null,
                    ToBePaidAmt: row0.item.ToBePaidAmt || null,
                  }" />
                </div>
              </template>
              <template slot="SN" slot-scope="row0">
                <span>
                  {{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}
                </span>
              </template>

              <template slot="invoiceNumber" slot-scope="row1">
                <strong>Transaction No:</strong>{{ row1.item.sprf_transaction_no }}<br />
                <strong>Inv No:</strong>{{ row1.item.invoiceNumber }}<br />
                <strong>Inv Date:</strong> {{ row1.item.paymentCreatedDate }}<br />
                <strong>Inv Amt:</strong> {{ row1.item.amount }}<br />
                <b-badge v-if="isShortlisted(row1.item) || row1.item.sps_is_sortlist"
                  variant="success">Shortlisted</b-badge>
                <b-badge v-if="row1.item.sps_is_finalized" variant="success">Finalized</b-badge>
              </template>

              <template slot="JobNo" slot-scope="row1">
                <strong>Job No:</strong> {{ row1.item.JobNo }}<br />
                <strong>Job Date:</strong> {{ row1.item.JobDate }}<br />
              </template>

              <template slot="ClientName" slot-scope="row1">
                <strong>Pay To:</strong> {{ row1.item.pay_to }}<br />
                <strong>Forwarder Name:</strong> {{ row1.item.ForwarderName }}<br />
                <strong>Sline Name:</strong> {{ row1.item.SlineName }}<br />
                <strong>Client:</strong> {{ row1.item.ClientName }}<br />
              </template>

              <template slot="POR" slot-scope="row1">
                <strong>POR:</strong> {{ row1.item.POR }}<br />
                <strong>POL:</strong> {{ row1.item.POL }}<br />

              </template>

              <template slot="EnqNo" slot-scope="row1">
                <strong>Enq No:</strong> {{ row1.item.EnqNo }}<br />
                <strong>Enq Date:</strong> {{ row1.item.EnqDate }}<br />
                <strong>SOB Date:</strong> {{ row1.item.SOB }}<br />
                <strong>Payment Module Type:</strong> {{ row1.item.paymentModuleType }}<br />
              </template>

              <!-- Expandable Row for Additional Details -->

              <template slot="row-details" slot-scope="row4">
                <b-card style="background: whiteSmoke">
                  <b-row>
                    <b-col md="3" class="mb-2" v-if="row4.item.invoiceType">
                      <span><b>Inv Type:</b> {{ row4.item.invoiceType }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.invoiceCategory">
                      <span><b>Inv Category :</b> {{ row4.item.invoiceCategory }}<br /></span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.currency">
                      <span><b>Inv Currency :</b> {{ row4.item.currency }}<br /></span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.slineBlNo">
                      <span><b>Inv Bl No :</b> {{ row4.item.slineBlNo }}<br /></span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.dueDate">
                      <span><b>Due Date :</b> {{ row4.item.dueDate }}<br /></span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.sobDate"><span><b>Sob Date :</b> {{
                      row4.item.sobDate }}<br /></span></b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.paymentCreatedBy"><span><b>Inv Created By :</b>
                        {{ row4.item.paymentCreatedBy }}<br /></span></b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.JobType"><span><b>Job Type :</b>{{
                      row4.item.JobType }}<br /></span></b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.JobTransportType">
                      <span><b>Transport Type:</b> {{ row4.item.JobTransportType }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.JobTContainerType">
                      <span><b>Container Type:</b> {{ row4.item.JobTContainerType }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.RaisedFrom">
                      <span><b>Raised From:</b> {{ row4.item.RaisedFrom }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.RaisedBy">
                      <span><b>Raised By:</b> {{ row4.item.RaisedBy }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.HBL">
                      <span><b>HBL:</b> {{ row4.item.HBL }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.MBL">
                      <span><b>MBL:</b> {{ row4.item.MBL }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.HBL">
                      <span><b>HBL:</b> {{ row4.item.HBL }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.MBLDate">
                      <span><b>MBL Date:</b> {{ row4.item.MBLDate }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.MBLReleaseDate">
                      <span><b>MBL Release Date:</b> {{ row4.item.MBLReleaseDate }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.ExpClientName">
                      <span><b>Exp Client Name:</b> {{ row4.item.ExpClientName }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.ImpClientName">
                      <span><b>Imp Client Name:</b> {{ row4.item.ImpClientName }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.POD">
                      <span><b>POD:</b> {{ row4.item.POD }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.FPOD">
                      <span><b>FPOD:</b> {{ row4.item.FPOD }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.PICK">
                      <span><b>PICK:</b> {{ row4.item.PICK }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.STUFF">
                      <span><b>STUFF:</b> {{ row4.item.STUFF }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.HAND">
                      <span><b>HAND:</b> {{ row4.item.HAND }}</span>
                    </b-col>
                  </b-row>
                </b-card>
              </template>


            </b-table>
          </b-col>
          <b-col md="12">
            <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
              :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <b-modal no-close-on-esc no-close-on-backdrop id="confirm-bulk-payment" ref="confirm-bulk-payment"
      title="Confirm Final to Release" class="w-90" size="xl" hide-footer>
      <b-row>
        <b-col md="12">
          <h5>Are you sure you want to proceed with this Invoice to Finalize?</h5>
        </b-col>
      </b-row>
      <b-card v-if="selectedCheckBoxRows.length > 0">
        <b-card-body>

          <b-row>

            <b-col md="12">
              <h2 class="mb-4">📦 Shipping Line Summary</h2>
              <h1 v-if="alert.content" class="error">{{ alert.content }}</h1>
              <b-row>
                <b-col md="12" v-for="summary in shippingSummaryData" :key="summary.shippingId" class="mb-4">
                  <div class="border p-3 rounded bg-light">
                    <h6 class="mb-3">{{ summary.shippingLine }}</h6>
                    <b-row>
                      <b-col md="4">
                        <label>Shipping Line</label>
                        <!-- Shipping Line Dropdown -->
                        <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                          v-model="summary.fk_sline_id" option-value="shippingId" option-text="shippingLine"
                          placeholder="Select Shipping Line" class="mb-3" :isDisabled="true"
                          @input="onShippingLineChange(summary.shippingId, summary.fk_sline_id)" />
                      </b-col>

                      <b-col md="3" class="mb-3" v-if="summary.fk_sa_id">
                        <label>Currecny</label>
                        <model-list-select :list="$store.getters['common/getAllCurrencyList']"
                          v-model="summary.fk_currency_id" option-value="currency_id" option-text="currencyCode"
                          placeholder="Select Currency"
                          @input="getCurrencyDetails(summary.shippingId, summary.fk_currency_id)" />

                      </b-col>
                    </b-row>

                    <p><strong>Currency-wise Totals:</strong></p>
                    <ul class="list-unstyled">
                      <li v-for="(amt, cur) in summary.currencyTotals" :key="cur">
                        {{ cur }}: ₹{{ amt.toLocaleString() }}
                      </li>
                    </ul>
                    <div class="mt-3 table-responsive-child" v-if="summary.items.length > 0">
                      <h6 class="mb-3">Invoice Details</h6>
                      <table class="table table-bordered table-sm table-hover">
                        <thead class="thead-light">
                          <tr>
                            <th :style="'width:5%'">Job No</th>
                            <th :style="'width:5%'">Job Date</th>
                            <th :style="'width:8%'">Inv No</th>
                            <th :style="'width:5%'">Inv Created</th>
                            <th :style="'width:10%'">Inv Type</th>
                            <th :style="'width:5%'">Inv Amt</th>
                            <th :style="'width:20%'">Pay To</th>
                            <th :style="'width:8%'">Account No</th>
                            <th :style="'width:5%'">IFSC Code</th>
                            <th :style="'width:10%'">To Be Paid</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item1, index1) in summary.items" :key="index1">
                            <td>{{ item1.JobNo }}</td>
                            <td>{{ item1.JobDate }}</td>
                            <td>{{ item1.InvNumber }}</td>
                            <td>{{ item1.paymentCreatedDate }}</td>
                            <td>{{ item1.invoiceType }}</td>
                            <td>{{ item1.amount }}</td>
                            <td><model-list-select :list="summary.getSlineAccList" v-model="item1.fk_sa_id"
                                option-value="value" option-text="label" placeholder="Select Account" class="mb-3"
                                @input="getAccontDetailsItem(summary.shippingId, item1, index1, item1.fk_sa_id)" /></td>
                            <td>{{ item1.payTo }}</td>
                            <td>{{ item1.IFSCCode }}</td>
                            <td><b-form-input v-if="item1.fk_sa_id" type="text" :formatter="capitalizeAll"
                                placeholder="To Be Paid Amount" v-model.number="item1.ToBePaidAmt" class="mb-3"
                                :state="item1.ToBePaidAmt <= item1.amount" />{{
                                  item1.ToBePaidAmt }}

                              <!-- v-model="item1.ToBePaidAmt" -->
                              <small v-if="item1.ToBePaidAmt > item1.amount" class="text-danger">
                                Amount must be less than or equal to ₹{{ item1.amount }}
                              </small>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- Summary Total -->
                    <p class="mt-2"><strong>Total: ₹{{ summary.total.toLocaleString() }}</strong></p>

                  </div>
                </b-col>
              </b-row>

              <hr />
              <h5 class="mt-4 text-right">🧾 Grand Total: ₹{{ shippingGrandTotal.toLocaleString() }}</h5>
              <div v-for="(amount, currency) in shippingGrandTotalCurrencyWise" :key="currency">
                <h5 class="mt-4 text-right">🧾 Grand Total in {{ currency }}: {{ amount }}</h5>
              </div>
            </b-col>
            <b-col md="8" class=" mt-2" v-if="selectedCheckBoxRows.length > 0">
              <h1 v-if="alert.content" class="error">{{ alert.content }}</h1>
              <b-button class="mr-2 btn-sm" variant="primary" @click="handleConfirmOk"
                :disabled="selectedCheckBoxRows.length <= 0">

                <span v-if="!isBulkPaymentProcessing">Finalize Request</span>
                <span v-else>
                  <b-spinner small class="mr-2"></b-spinner>
                  Processing...
                </span>
              </b-button>
              <b-button class="mr-2 btn-sm" variant="outline-danger" @click="resetModal">
                Cancel
              </b-button>
            </b-col>



          </b-row>
        </b-card-body>
      </b-card>


      <!-- You could also include item details here if needed -->
    </b-modal>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat, excelSerialToDate } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import NodeLockPannelService from "../../services/NodeLockPannelService";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";

export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      ),
      this.$store.dispatch("common/setAllAgentColoaderList"),
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({ itemCode: "ShippingLineList" })
      ),
      this.$store.dispatch(
        "common/setAllLocationDetailsFinalList",
        JSON.stringify({ itemCode: "LocationDetailsFinalList" })
      ),
      this.$store.dispatch(
        "common/setAllPORList",
        JSON.stringify({ itemCode: "PORList" })
      ),
      this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({ itemCode: "PODList" })
      ),
      this.$store.dispatch(
        "common/setAllPOLList",
        JSON.stringify({ itemCode: "POLList" })
      ),
      this.$store.dispatch(
        "commonDropdownMaster/setAllSlineAccDDList",
        JSON.stringify({
          itemCode: "AllSlineAccDDList",
        })
      ),
      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      ),
      this.$store.dispatch(
        "commonDropdownMaster/setAllPendingSlineInvDDList",
        {
          itemCode: "LocationList",
          isSelectedColumn: '1',
          isAll: '1',
          page: 1,
          pageSize: 1,
          generateExcel: 0,
          search_txt: '',
          filter: '',
        }
      ),
    ];
    // Function to introduce a delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    // Wait for all store actions to complete
    Promise.all(storePromises)
      .then(() => delay(5000)) // Wait for 5 seconds
      .then(() => {
        // After the delay, execute the next function

      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });

    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.getCurrentLastDate();

    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getSlinePlanningList("Normal", "0", "0", "1", "1");
    }
  },
  mounted() {

  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      shippingSummaryData: [],
      fk_sline_id: "",
      fk_sa_id: "",
      errMSG: "",
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      ExcelBtnName1: "Export And Import",
      visible: false,
      getPaymentList: [],
      totalData: 0,

      validate: true,

      // Date format for datepickers

      dateFormat: { year: "numeric", month: "short", day: "numeric" },
      confirmFields: [
        { key: 'SN', label: 'SN' },
        { key: 'paymentModuleType', label: 'Module' },
        { key: 'JobNo', label: 'Job No.' },
        { key: 'SlineName', label: 'Sline Name' },
        { key: 'InvNumber', label: 'Invoice No.' },
        { key: 'InvAmt', label: 'Amount' },
        { key: 'currency', label: 'Currency' },
      ],
      isBulkPaymentProcessing: false,
      selectedCheckBoxRows: [],
      PaymentFields: [
        {
          key: 'checkbox',   // Our custom field name for checkboxes
          mainkey: "checkbox",
          label: 'Select',         // No label, or you can put "Select"
          sortable: false,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "invoiceNumber",
          mainkey: "invoiceNumber",
          label: "Inv Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "Job Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "ClientName",
          mainkey: "ClientName",
          label: "Client/Sline Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "POR",
          mainkey: "POR",
          label: "Loc Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "EnqNo",
          mainkey: "EnqNo",
          label: "Enq Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,


      shipmentTypeList: [
        {
          text: "Sea",
          value: "Sea",
        },
        {
          text: "Air",
          value: "Air",
        },
      ],
      SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      paymentTypeList: [
        {
          text: "FF Export",
          value: "FF",
        },
        {
          text: "CC Export",
          value: "CC",
        },
        {
          text: "Import",
          value: "IMP",
        },
      ],
      transportTypeList: [
        {
          text: "EXPORT",
          value: "EXPORT",
        },
        {
          text: "IMPORT",
          value: "IMPORT",
        },
        {
          text: "CROSS COUNTRY",
          value: "CRC",
        },
      ],
      dateTypeList: [
        {
          text: "Job",
          value: "1",
        },
        {
          text: "Payment Request Date",
          value: "2",
        },
      ],
      Filter: {
        DateTypeFilter: "2",
        JobNoFilter: "",
        clientFilter: "",
        slineFilter: "",
        TransportTypeFilter: "",
        paymentTypeFilter: "",
        SOBFilter: "3",
        ShipemntTypeFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "2",
        commonFilter: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      //Added By Priyanshu Singh Multi Select Start

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
      ExpImpType: "0",
      isSubmited: false,
      isFileLoading: false,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {
    // If number of selected rows = total rows in getPaymentList
    allSelected() {
      return this.selectedCheckBoxRows.length === this.getPaymentList.length;
    },
    shippingGrandTotal() {
      return this.shippingSummaryData.reduce((sum, s) => sum + s.total, 0);
    },
    shippingGrandTotalCurrencyWise() {
      const grandCurrencyTotals = {};

      this.shippingSummaryData.forEach(summary => {
        for (const [currency, amount] of Object.entries(summary.currencyTotals)) {
          if (!grandCurrencyTotals[currency]) {
            grandCurrencyTotals[currency] = 0;
          }
          grandCurrencyTotals[currency] += amount;
        }
      });

      return grandCurrencyTotals;
    },
  },
  watch: {
    selectedCheckBoxRows: {
      immediate: true,
      handler(newVal) {
        const summaryMap = {};
        let grandTotal = 0;

        newVal.forEach(item => {
          const { SlineName, shippingId, InvAmt, currency } = item;
          item.fk_sa_id = null;

          // Initialize per shipping line
          if (!summaryMap[shippingId]) {
            const getSlineAccList = this.$store.getters['commonDropdownMaster/getAllSlineAccList']
              .filter(x => x.fk_sline_id == shippingId);

            summaryMap[shippingId] = {
              fk_sline_id: shippingId.toString(),
              fk_sa_id: null,
              fk_currency_id: null,
              getSlineAccList,
              shippingLine: SlineName,
              shippingId,
              items: [],
              total: 0,
              payTo: '',
              IFSCCode: '',
              BranchName: '',
              selectedAmt: 0,
              ToBePaidAmt: 0,
              currencyTotals: {}, // 👈 each shipping line has their own currency total
            };
          }

          const summary = summaryMap[shippingId];

          summary.items.push(item);
          summary.total += InvAmt;
          grandTotal += InvAmt;

          // 👇 Calculate currency total per shipping line
          if (!summary.currencyTotals[currency]) {
            summary.currencyTotals[currency] = 0;
          }
          summary.currencyTotals[currency] += InvAmt;
        });

        this.shippingSummaryData = Object.values(summaryMap);
      }
    }
  },

  methods: {

    getAccontDetailsItem(shippingId, InvItem, indexInv, fk_sa_id) {
      const getSlineAccList = this.$store.getters['commonDropdownMaster/getAllSlineAccList']
        .filter(x => x.sa_id == fk_sa_id);

      if (getSlineAccList.length > 0) {
        const item = getSlineAccList[0];
        const index = this.shippingSummaryData.findIndex(s => s.shippingId === shippingId);
        console.log('indexInv', indexInv, item);

        if (index !== -1) {
          const summary = this.shippingSummaryData[index];

          // Ensure reactivity
          this.$set(this.shippingSummaryData[index].items[indexInv], 'payTo', item.label);
          this.$set(this.shippingSummaryData[index].items[indexInv], 'IFSCCode', item.sa_ifsc);
          this.$set(this.shippingSummaryData[index].items[indexInv], 'BranchName', item.sa_branch);
          this.$set(this.shippingSummaryData[index].items[indexInv], 'selectedAmt', InvItem.selectedAmt);
          this.$set(this.shippingSummaryData[index].items[indexInv], 'ToBePaidAmt', InvItem.selectedAmt);

          // Optional debug log
          console.log('Updated summary getAccontDetailsItem:', this.shippingSummaryData[index]);
        }
      }
    },
    getCurrencyDetails(shippingId, fk_currency_id) {
      const index = this.shippingSummaryData.findIndex(s => s.shippingId === shippingId);
      if (index !== -1) {
        const summary = this.shippingSummaryData[index];

        this.$set(this.shippingSummaryData[index], 'fk_currency_id', fk_currency_id);
      }
    },
    onShippingLineChange(shippingId, selectedShippingLine) {
      const summary = this.shippingSummary.summaries.find(summary => summary.shippingId === shippingId);

      if (summary) {
        // Update the fk_sline_id when the shipping line is selected
        summary.fk_sline_id = selectedShippingLine;

        // Optionally, trigger any additional logic (like validation or API calls)
        console.log(`Shipping Line ID for ${summary.shippingLine} updated to: ${selectedShippingLine}`);
      }
    },
    openConfirmModal() {
      this.$refs["confirm-bulk-payment"].show();
    },
    async handleConfirmOk() {
      this.alert.content = "";
      this.errMSG = "";
      if (this.selectedCheckBoxRows.length > 20 && this.selectedCheckBoxRows.length <= 2) {
        this.alert.content = "Please select maximum 20 invoices for Finalize to Request Invoice";
        this.errMSG = "Please select maximum 20 invoices for Finalize to Request Invoice";
        // this.$refs["addPop"].open();
        return false;
      }
      if (this.validate == true) {
        if (this.selectedCheckBoxRows.length <= 0) return;
        try {
          this.isBulkPaymentProcessing = true;
          await this.requestFinalize(this.selectedCheckBoxRows);
        } catch (err) {
          console.error("Bulk payment failed:", err);
        } finally {
          this.isBulkPaymentProcessing = false;
        }
      }
    },
    resetModal() {
      // Reset state each time modal is closed
      this.selectedCheckBoxRows = [];
      this.errMSG = "";
      this.$refs["confirm-bulk-payment"].hide();
    },

    async requestFinalize() {
      try {
        let payload = { invoices: this.shippingSummaryData, payment: this.payment, LabelType: 'request-final' };
        console.log('this.selectedCheckBoxRows=>', this.shippingSummaryData, payload)
        // return;

        if (!this.shippingSummaryData || this.shippingSummaryData.length === 0) {
          console.error("No selected invoices for payment.");
          return;
        }
        console.log("Selected invoices for payment:", this.shippingSummaryData);

        // Validate required fields
        const missingFields = [];
        const missingAmountFields = [];
        this.shippingSummaryData.forEach((item, index) => {
          item.items.forEach((item1) => {
            // if (!item1.fk_sline_id) missingFields.push(`Row ${index + 1}: Missing fk_sline_id`);
            if (!item1.fk_sa_id) missingFields.push(`Row ${index + 1}: Missing Pay To`);
            if (!item1.ToBePaidAmt) missingFields.push(`Row ${index + 1}: Missing Paid Amount`);
            if (item1.ToBePaidAmt > item1.amount) missingAmountFields.push(`Row ${index + 1}: Amount must be less than or equal to ₹${item1.amount}`);
            // if (!item1.fk_currency_id) missingFields.push(`Row ${index + 1}: Missing fk_currency_id`);
          });
          const missing = [];
          if (!item.fk_sline_id) missing.push('fk_sline_id');
          // if (!item.fk_sa_id) missing.push('fk_sa_id');
          // if (!item.fk_currency_id) missing.push('fk_currency_id');

          if (missing.length > 0) {
            missingFields.push(`Row ${index + 1}: Missing ${missing.join(', ')}`);
          }
        });

        if (missingFields.length > 0) {
          // console.error("Validation failed:\n" + missingFields.join('\n'));

          this.alert.content = "Pls check Amount must be less than or equal to the Invoice Amount";
          // this.$refs["addPop"].open();
          return;
        }

        if (missingAmountFields.length > 0) {
          // console.error("Validation failed:\n" + missingFields.join('\n'));

          this.alert.content = "Some required fields are missing in selected invoices,Pay To,To Be Paid Amount. Please review.";
          // this.$refs["addPop"].open();
          return;
        }

        // return false;
        const response = await NodeLockPannelService.SlineRequestFinalize(payload, {})

        // Handle API response
        if (response.data.status) {
          this.resetModal();
          this.getSlinePlanningList("Normal", "0", "0", "1", "1");
          console.info(response.data.message || "Bulk payment processed successfully.");
        } else {
          console.error(response.data.message || "Bulk payment failed.");
        }

      } catch (error) {
        console.error("Bulk Payment Error:", error);
        console.error("An error occurred while processing Finalize to Request Invoice.");
      } finally {
        this.isBulkPaymentProcessing = false; // Hide loading indicator
      }
    },
    isShortlisted(item) {
      return this.selectedCheckBoxRows.some(selected =>
        selected.invoicePayID === item.invoicePayID &&
        selected.invoiceID === item.invoiceID
      );
    },
    rowClass(item) {
      return this.isShortlisted(item) ? 'shortlisted-row' : '';
    },
    toggleSelectAll(checked) {
      if (checked) {
        // Select all rows -> store only the 3 keys in each object
        // this.selectedCheckBoxRows = this.getPaymentList.map(item => ({
        //   paymentModuleType: item.paymentModuleType,
        //   sprf_id: item.sprf_id,
        //   sps_id: item.sps_id,
        //   sps_is_sortlist: item.sps_is_sortlist,
        //   sps_is_finalized: item.sps_is_finalized,
        //   invoicePayID: item.invoicePayID,
        //   invoiceID: item.invoiceID,
        //   invoiceAmtID: item.invoiceAmtID,
        //   JobId: item.JobId,
        //   JobNo: item.JobNo,
        //   InvNumber: item.invoiceNumber,
        //   InvAmt: item.amount,
        //   currency: item.currency,
        //   SlineName: item.SlineName,
        //   shippingId: item.shippingId
        // }));

        this.selectedCheckBoxRows = this.getPaymentList
          .filter(item => !item.sprf_transaction_no)
          .map(item => ({
            paymentModuleType: item.paymentModuleType,
            sprf_id: item.sprf_id,
            sps_id: item.sps_id,
            sps_is_sortlist: item.sps_is_sortlist,
            sps_is_finalized: item.sps_is_finalized,
            invoicePayID: item.invoicePayID,
            invoiceID: item.invoiceID,
            invoiceAmtID: item.invoiceAmtID,
            JobId: item.JobId,
            JobNo: item.JobNo,
            InvNumber: item.invoiceNumber,
            InvAmt: item.amount,
            currency: item.currency,
            SlineName: item.SlineName,
            shippingId: item.shippingId,
            fk_sa_id: item.fk_sa_id || null,
            JobDate: item.JobDate || null,
            paymentCreatedDate: item.paymentCreatedDate || null,
            invoiceType: item.invoiceType || null,
            amount: item.amount || null,
            payTo: item.payTo || null,
            IFSCCode: item.IFSCCode || null,
            BranchName: item.BranchName || null,
            selectedAmt: item.amount || null,
            ToBePaidAmt: item.ToBePaidAmt || null,
          }));

      } else {
        // Clear selection
        this.selectedCheckBoxRows = [];
      }
    },

    clearFilter() {
      this.Filter = {
        DateTypeFilter: "2",
        JobNoFilter: "",
        clientFilter: "",
        slineFilter: "",
        TransportTypeFilter: "",
        paymentTypeFilter: "",
        SOBFilter: "3",
        ShipemntTypeFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "2",
        commonFilter: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getSlinePlanningList("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();

      // Subtract 1 day from today to get the previous day
      var previousDay = new Date();
      previousDay.setDate(today.getDate() - 1);

      // Format yesterday's date (DD/MM/YYYY)
      var prev_dd = String(previousDay.getDate()).padStart(2, "0");
      var prev_mm = String(previousDay.getMonth() + 1).padStart(2, "0");
      var prev_yyyy = previousDay.getFullYear();
      var startDate = `${prev_yyyy}/${prev_mm}/${prev_dd}`; // 11/02/2025

      // Format today's date (DD/MM/YYYY)
      var today_dd = String(today.getDate()).padStart(2, "0");
      var today_mm = String(today.getMonth() + 1).padStart(2, "0");
      var today_yyyy = today.getFullYear();
      var endDate = `${today_yyyy}/${today_mm}/${today_dd}`; // 12/02/2025

      // Set startDate and endDate
      this.startDate = startDate;
      // this.Filter.dateRange = {
      //   startDate: startDate, // 11/02/2025
      //   endDate: endDate,     // 12/02/2025
      // };
    },

    getSlinePlanningList(type, filterIdD, CURRENT, SEARCH, pageNumber) {

      this.totalData = 0;
      this.getPaymentList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
        ExpImpType: this.ExpImpType,
        is_sortlisted: 1,
        is_finalized: 1,
        is_finalizedStatus: 1,
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getAllPaymentPLanningJobList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              // Handle file download
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Sales-Payment-panel-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.ExcelBtnName1 = "Export And Import";
              this.generateExcel = "0";
              this.ExpImpType = "0";
              this.getSlinePlanningList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.pagination.totalPaymentList;
                this.getPaymentList = data.data;
                this.pagination.totalRows = data.pagination.totalPaymentList;
                this.pagination.currentPage = data.pagination.currentPage;
                this.pagination.perPage = data.pagination.pageSize;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getPaymentList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getSlinePlanningList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExpImpType = "1";
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getSlinePlanningList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getSlinePlanningList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getSlinePlanningList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>
<style>
.shortlisted-row {
  background-color: #e6ffed !important;
  /* light green */
}

h3 {
  color: #2c3e50;
  margin-top: 1rem;
}

ul {
  margin-left: 1rem;
}

hr {
  margin: 2rem 0;
}

.table-responsive-child {
  max-height: 300px;
}

.w-90 .modal-dialog {
  max-width: 90% !important;
  margin: 0 auto !important;
}
</style>



// WEBPACK FOOTER //
// slinePaymentSortFinalList.vue?75226e29